import React from "react";
import { IoClose } from "react-icons/io5";
import { StatusBadge } from "./StatusBadge";
import { StockSummaryRow } from "@/types";
import { StockRequestApiItem } from "@/services/stockSummaryService";

const RequestDetails = ({
  selectedRequest,
  closeDetailsPanel,
  formatDetailValue,
  getDetailedEntries,
}: {
  selectedRequest:  StockSummaryRow | null;
  closeDetailsPanel: () => void;
  formatDetailValue:  (value: unknown) => string;
  getDetailedEntries: (request: StockRequestApiItem) => {
    label: string;
    value: string | null | undefined;
}[]
}) => {
  return (
    <aside
      className={`fixed right-0 top-0 z-50 h-full w-full max-w-3xl transform bg-white shadow-2xl transition-transform duration-300 xl:max-w-5xl 2xl:max-w-360 ${
        selectedRequest ? "translate-x-0" : "translate-x-full"
      }`}
      aria-hidden={!selectedRequest}
    >
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4">
          <div>
            <h3 className="text-lg font-bold text-[#0f1f4b]">
              Request Details
            </h3>
            <p className="mt-1 text-sm text-slate-500">
              All response fields for the selected request
            </p>
          </div>
          <button
            type="button"
            onClick={closeDetailsPanel}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-slate-100 text-slate-600 transition-colors hover:bg-slate-200"
            aria-label="Close details panel"
          >
            <IoClose size={18} />
          </button>
        </div>

        <div className="flex-1 space-y-4 overflow-y-auto px-5 py-5 xl:px-6">
          {selectedRequest && (
            <>
              <div className="rounded-2xl bg-slate-50 p-4">
                <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                  Current Status
                </div>
                <div className="mt-2">
                  <StatusBadge status={selectedRequest.status} />
                </div>
              </div>

              {selectedRequest.status === "Cancelled" && (
                <div className="rounded-2xl border border-red-100 bg-red-50 p-4">
                  <div className="text-xs font-semibold uppercase tracking-[0.18em] text-red-400">
                    Cancellation Reason
                  </div>
                  <div className="mt-1 wrap-break-word text-sm font-medium text-red-600">
                    {selectedRequest.details.cancellationReason?.trim() || "--"}
                  </div>
                </div>
              )}

              <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
                {getDetailedEntries(selectedRequest.details).map((entry) => (
                  <div
                    key={entry.label}
                    className="rounded-xl border border-slate-200 bg-white px-4 py-3"
                  >
                    <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">
                      {entry.label}
                    </div>
                    <div className="mt-1 wrap-break-word text-sm font-medium text-slate-700">
                      {formatDetailValue(entry.value)}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </aside>
  );
};

export default RequestDetails;
